'use es6';

import { getUrl } from '../../common/urls';
import { search } from '../dao';
import { generate } from '../generate';
import { transform } from './transform';
export default ((spec, config, runtimeOptions) => generate(config, null).then(payload => search(getUrl(config, runtimeOptions), payload)).then(response => transform(config, response)));